import {Component, Input, OnInit} from '@angular/core';
import {ColDef, ColumnApi, GridApi, GridReadyEvent} from 'ag-grid-community';
import {ColliEvent} from '../../models/colliEventsModel';
import {faCaretDown, faCaretUp} from '@fortawesome/free-solid-svg-icons';
import {AG_GRID_LOCALE_DE} from '../../locale.de';
import {ColliInfoCellComponent} from './colli-info-cell/colli-info-cell.component';


@Component({
  selector: 'lib-colli-events',
  templateUrl: './colli-events.component.html',
  styleUrls: ['./colli-events.component.scss']
})
export class ColliEventsComponent implements OnInit {

  public gridApi: GridApi;
  public gridColumnApi: ColumnApi;
  public columnDef: ColDef[];
  public defaultColDef: ColDef;
  public show: boolean;
  public isCollapsed: boolean = false;
  public carretUp = faCaretUp;
  public carretDown = faCaretDown;

  public locale = AG_GRID_LOCALE_DE;

  @Input() colliEvent: ColliEvent[];

  constructor() {

    this.defaultColDef = {
      resizable: true,
      sortable: true,
      filter: true,
      flex: 1,
      lockPosition: true,
      cellClass: 'locked-col'
    };

    this.columnDef = [
      {
        field: 'scantyp',
        headerName: 'Typ',
        minWidth: 100
      },
      {
        field: 'tournr',
        headerName: 'Tournr',
        maxWidth: 100
      },
      {
        field: 'statustyp',
        headerName: 'CE'
      },
      {
        field: 'depotnr',
        headerName: 'DepotNr',
        maxWidth: 120
      },
      {
        field: 'barcode',
        headerName: 'Barcode',
        minWidth: 250
      },
      {
        valueGetter: this.sliceTime,
        headerName: 'Datum/Zeit',
        minWidth: 150,
        sort: 'desc'
      },
      {
        field: 'geraetenummer',
        headerName: 'Gerät',
        maxWidth: 200
      },
      {
        field: 'istRutsche',
        headerName: 'Rutsche',
        maxWidth: 130
      },
      {
        field: 'storno',
        headerName: 'Storno',
        maxWidth: 100
      },
      {
        headerName: 'Hinweise',
        cellRendererFramework: ColliInfoCellComponent,
        maxWidth: 150
      },
    ];
  }

  ngOnInit(): void {
  }

  gridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.colliEvent);
    //console.log('params', this.colliEvent);
 
    this.colliEvent.sort((a,b)=>{
      const dateA = new Date(a.zeitpunkt);
      const dateB = new Date(b.zeitpunkt);
      return dateB.getTime() - dateA.getTime();
    })
  }

  sliceTime(params: any) {
    return params.data?.zeitpunkt?.slice(0, 16);
  }
}
